import React, { useEffect } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';

const AcceptanceForm = ({ fetchHubspotFormStatus, currentApplicant, courseApplicationData }) => {
  useEffect(() => {
    document.title = "Accept Admission Offer | LaunchCode";
  }, []);

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: '5546754',
    formId: 'c694050b-6067-4ce1-aa8f-0bcac42730da',
    target: '#course-application',
    onFormReady: function($form){
      var $theEmail = $form.find('input[name="email"]');
      $theEmail.val(currentApplicant.email).change();
    },
    onFormSubmitted: function($form) {
      fetchHubspotFormStatus('admission_offered');
    }
  });

  return (
    <>
      <h2>Accept Admission Offer</h2>
      <div id='course-application'></div>
    </>
  )
};

export default AcceptanceForm;
